import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=d059bcb4&scoped=true"
import script from "./informacion.vue?vue&type=script&lang=js"
export * from "./informacion.vue?vue&type=script&lang=js"
import style0 from "./informacion.vue?vue&type=style&index=0&id=d059bcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d059bcb4",
  null
  
)

export default component.exports